enum PrivateEventStatesEnum {
  Upcoming = 'Upcoming',
  InProgress = 'In Progress',
  Finished = 'Finished',
  Canceled = 'Canceled',
}

export default PrivateEventStatesEnum;
